import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, UrlMatcher } from '@angular/router';
import { AuthGuardService } from './services';
import { NgDocGuardService } from './services/ngdoc-guard.service';

// Match any path that starts with 'docs' and consume the rest
export const docsMatcher: UrlMatcher = (segments) => {
  if (segments.length && segments[0].path === 'docs') {
    // Skip matching for docs/home and docs/dashboard - If any user has profile name as docs then
    // these routes need to work as is #PD-122242 Fix
    if (
      segments.length > 1 &&
      (segments[1].path === 'home' || segments[1].path === 'dashboard')
    ) {
      return null;
    }
    return { consumed: segments };
  }
  return null;
};

const APP_ROUTES = [
  {
    path: 'account',
    loadChildren: () =>
      import('../account/account-layout.module').then(
        (m) => m.AccountLayoutModule
      ),
  },
  // Public standalone legal pages (privacy policy, cookie notice) — no auth guard, no learner shell
  {
    path: 'cookie-notice',
    loadChildren: () =>
      import('@degreed/lxp/ui/legal').then((m) => m.COOKIE_NOTICE_ROUTES),
  },
  {
    path: 'privacy-policy',
    loadChildren: () =>
      import('@degreed/lxp/ui/legal').then((m) => m.PRIVACY_POLICY_ROUTES),
  },
  {
    path: 'orgs',
    loadChildren: () => import('../orgs/orgs.module').then((m) => m.OrgsModule),
  },
  {
    path: 'channel',
    loadChildren: () =>
      import('../channel/channel.module').then((m) => m.ChannelModule),
  },
  {
    path: 'analytics',
    loadChildren: () =>
      import('../analytics/analytics.module').then((m) => m.AnalyticsModule),
  },
  {
    matcher: docsMatcher,
    loadComponent: () =>
      import('../docs/docs-container.component').then(
        (m) => m.DocsContainerComponent
      ),
    canMatch: [AuthGuardService, NgDocGuardService],
  },
  {
    path: '',
    loadChildren: () =>
      import('../learner-experience/v3/learner-experience.module').then(
        (m) => m.LearnerExperienceModule
      ),
  },
  {
    path: 'validate-email-link-expired',
    loadComponent: () =>
      import('../error-handling/components/verify-email-error/verify-email-error.component').then(
        (m) => m.VerifyEmailErrorComponent
      ),
  },
  // Explicit error route for programmatic navigation (e.g., router.navigate(['/error-handler', '500']))
  // Passes error code as route param for clean Angular error handling
  {
    path: 'error-handler/:code',
    loadComponent: () =>
      import('../error-handling/components/handle-error/handle-error.component').then(
        (m) => m.HandleErrorComponent
      ),
  },
  // Wildcard route catches unmatched URLs (true 404s) and legacy MVC error handling
  // (where error codes are in the URL query string or path)
  {
    path: '**',
    loadComponent: () =>
      import('../error-handling/components/handle-error/handle-error.component').then(
        (m) => m.HandleErrorComponent
      ),
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(APP_ROUTES, {
      enableTracing: false,
    }),
  ],
  exports: [RouterModule],
  providers: [AuthGuardService, NgDocGuardService],
})
export class AppRoutingModule {}
